export default __webpack_public_path__ + "static/media/girl-icon.d210b027.svg";